import { Color, LuxButton } from '@lux/wardrobe-lib'
import { Dialog } from 'primereact/dialog'
import { useIntl } from 'react-intl'
import './DialogConfirmDeletePhotoFromPackage.scss'

const DialogConfirmDeletePhotoFromPackage = ({ storeName, visible, onHide, onConfirm }) => {
    const componentClass = 'smart-modals-dialog-confirm-delete-photo-from-package'

    const intl = useIntl()

    return (
        <Dialog
            draggable={false}
            visible={visible}
            onHide={() => onHide()}
            style={{ width: '30vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '70vw' }}>
            <div className={`${componentClass}__content`}>
                <div className={`${componentClass}__title text-bold`}>
                    {intl.formatMessage({
                        id: `modals.dialog.confirm.delete.from.package.photo.title`,
                        defaultMessage: 'Deletion confirmation',
                    })}
                </div>
                <div className={`${componentClass}__project-name text`}>
                    {intl.formatMessage({
                        id: 'modals.dialog.confirm.delete.photo.from.package.description',
                        defaultMessage: 'Are you sure you want to delete these Photos?',
                    })}
                </div>
                <div className={`${componentClass}__project-name text`}>{storeName}</div>
                <div className={`${componentClass}__footer`}>
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'modals.dialog.confirm.delete.photo.cancel',
                            defaultMessage: 'Cancel',
                        })}
                        variant="outlined"
                        color={Color.WHITE}
                        onClick={onHide}
                    />
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'modals.dialog.confirm.delete.photo.confirm',
                            defaultMessage: 'Confirm',
                        })}
                        color={Color.WARNING}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </Dialog>
    )
}

export default DialogConfirmDeletePhotoFromPackage
